import { SVGProps } from 'react';

const Star = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fill={fill}
      d="m5.496 4.893-4.253.617-.076.015a.667.667 0 0 0-.293 1.123l3.081 3-.726 4.236-.009.073a.667.667 0 0 0 .976.63l3.804-2 3.796 2 .066.03a.667.667 0 0 0 .902-.733l-.728-4.237 3.083-3 .052-.056a.667.667 0 0 0-.422-1.08l-4.254-.618-1.9-3.853a.667.667 0 0 0-1.197 0L5.496 4.893Z"
    />
  </svg>
);

export default Star;
